<template>
  <div class="container-fluid centix-grid-page fill" :id="gridID">

    <div class="container-fluid filter-container" v-on:click.ctrl="showHelp" v-if="showFilterBar">
      <div :class="{ container : showContainer }" >

        <div class="row no-gutters py-4">

         
          <div class="col-auto">
            <!-- Refresh btn left -->
            <div class="refresh_holder mr-1">
              <redo-button @click="refreshButtonClicked" :title="$t('refresh')" />
            </div>
          </div>

          <slot name="before-datasources-slot"></slot>
          <div v-if="hasDataSources" class="col-md-2">
            <select v-model="selectedDataSource" v-on:change="getData()" class="form-control">
              <option v-for="option in dataSource" v-bind:value="option.key" v-bind:key="option.key">
                {{ option.title }}
              </option>
            </select>
          </div>

          <slot name="before-filter-slot-search"></slot>
          <slot name="filter-slot-search" v-bind:data="searchExpressions">
            <div class="col">
              <barcode-input v-bind:value="searchExpressions['SEARCH']" v-on:input="searchExpressionChanged"/>
            </div>
          </slot>
          <slot name="after-filter-slot-search"></slot>

          <div class="col-md-2" v-show="!hideFilterButton  && hasFilters">
            <a v-bind:class="{ 'btn-primary' : filtersActive, 'btn-secondary' : !filtersActive }" class="btn dropdown-toggle filter-button" href="javascript:void(0)" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> {{ filtersButtonTitle }} </a>

            <div class="dropdown-menu dropdown-menu-right col-md-6 filter-dropdown" aria-labelledby="dropdownMenuLink">
              <div class="filter-wrapper px-4 py-3">
                <div v-for="(filter, index) in filters" v-bind:key="index">
                  <form-list-input
                    :label="filter.description"
                    :list-config="getListConfig(filter.singleMethod, filter.listMethod, filter.controller)"
                    v-model="filter.selectedKey"
                    :form-tag="'listinput' + index"
                    @change="filterKeyChanged(filter, $event)" />
                </div>
                <div class="row">
                  <div class="col-6 my-2" v-for="(filter, index) in dateFilters" :key="index">
                    <form-date-input
                      :ref="filter.reference"
                      :label="filter.description"
                      :form-tag="filter.selector"
                      v-model="filter.selectedDate"
                      @on-return="getData()" />
                  </div>
                  <div class="col">
                    <a class="btn btn-primary filter-button" href="javascript:void(0)" @click="getData()">{{ $t('search') }}</a>
                  </div>
                </div>
              </div>

              <div class="dropdown-divider"></div>

              <div class="px-4 py-3">
                <a class="btn filter-button" v-bind:class="{ 'btn-outline-secondary' : !filtersActive, 'btn-primary' : filtersActive }" href="javascript:void(0)" role="button" v-on:click="resetFilters()">{{ $t("grid.reset_filters") }}</a>
              </div>
            </div>
          </div>

          <div class="col-auto" v-if="showPinFilterButton">
            <div class="refresh_holder ml-1">
              <pin-button @click="pinButtonClicked" :is-active="pinnedFilter" />
            </div>
          </div>

        </div>

      </div>
    </div>
    <div class="row">
      <div class="col">
        <alerter ref="alertbox" />
      </div>
    </div>
    <div class="row" v-on:contextmenu.prevent="openDefaultContextMenu">
      <div class="col">

        <div :id="innerGridDivID" class="grid-container-row" v-bind:style="{ 'height': toPixels(gridSizeComputed) }">
          <component
            ref="grid"
            :is="gridBase"
            v-bind="gridBaseProps"
            v-on="gridBaseEventListeners"
            v-bind:rows="gridData"
            v-bind:columns="gridCols"
            v-bind:all-selected="allSelected"
            v-bind:order="orderBy"
            v-bind:mobile-view="isMobile"
            v-bind:multi-select="multiSelect"
            v-bind:single-select="singleSelect"
            v-bind:column-search="columnSearch"
            v-bind:show-load-more="showLoadMore"
            v-bind:is-loading="isLoading"
            v-bind:isHTMLGrid="isHTMLGrid"
            :select-first-row-on-mounted="selectFirstRowOnMounted"
            :emit-select-on-row="emitSelectOnRow"
            v-on:order-by="setSortOption"
            v-on:all-select-toggled="allSelectToggled"
            v-on:column-filtered="gridColumnFiltered"
            v-on:selection-changed="$emit('selection-changed', $event)"
            v-on:single-row-checked="$emit('single-row-checked', $event)"
            v-on:list-item-clicked="listItemClicked"
            v-on:list-item-clicked-right="listItemClickedRight"
            v-on:list-item-double-clicked="listItemDoubleClicked"
            v-on:load-more="loadMore"
            v-on:column-filtered-advanced="gridColumnFilteredAdvanced"
            v-bind:grid-id="gridID"
            v-bind:total-result-count="gridDataMeta.Count || 0"
            v-bind:grid-link="(row) => getGridLink(row)" />
        </div>
      </div>
    </div>
    <div class="container py-2">
      <div class="row">
        <div class="col">
          <loading-spinner v-bind:loading="loader.isBusy" v-bind:message="loader.loadingMessage" v-bind:no-margin="$refs.grid && selectedCount > 0" />
          <span v-if="$refs.grid && selectedCount > 0" class="font-weight-bold font-italic">{{ $t(notAllLoaded ? 'grid.rows_selected_checkbox' : 'grid.rows_selected_checkbox_2', { 0: selectedCount, 1: gridDataMeta.Count || 0 }) }}</span>
        </div>
      </div>

    </div>

    <field-dictionary-search
      v-bind:site-root="config.siteRoot"
      v-bind:web-controller="config.webController"
      v-bind:existing-flex-grid-columns="gridCols"
      v-on:flex-grid-changed="onFlexGridChanged"
      ref="fieldDictionary" />

    <flex-grid-layout-search
      :layoutName="layoutName"
      v-bind:site-root="config.siteRoot"
      v-bind:web-controller="config.webController"
      v-bind:security="config.security"
      v-bind:control-name="controlLayoutName"
      v-on:list-item-clicked="changeLayout"
      v-on:list-item-deleted="layoutDeleted"
      ref="flexGridLayoutSearch" />

    <flex-grid-layout-maintenance-view
      @layoutCreated="changeLayout"
      v-bind:site-root="config.siteRoot"
      v-bind:web-controller="config.webController"
      v-bind:security="config.security"
      ref="editLayout" />

    <context-menu
      ref="menu"
      v-on:opened="refreshContextMenu"
      v-on:closed="contextMenuClosed"
      :window-id="gridID">
      <ul slot-scope="menuScope">
        <context-menu-item
          v-for="(item, index) in contextMenuItemsForRow"
          v-bind:key="index"
          v-bind:item="item"
          v-bind:data="menuScope"
          v-bind:title-parameter="selectedCount"
          v-on:context-item-clicked="onContextItemClicked" />
        <context-menu-item
          v-for="(item, index) in baseContextMenuItems"
          v-bind:key="index + 'b'"
          v-bind:item="item"
          v-bind:data="menuScope"
          v-bind:title-parameter="selectedCount"
          v-on:context-item-clicked="onContextItemClicked" />
      </ul>
    </context-menu>

  </div>
</template>

<script>
import lodashDebounce from 'lodash/throttle';
import Grid from './GridBase.vue';
import Alerter from 'components/Alerter.vue';
import FieldDictionarySearch from 'components/Grid/FieldDictionarySearch.vue';
import FlexGridLayoutSearch from './FlexGridLayoutSearch.vue';
import LoadingSpinner from 'components/LoadingSpinner.vue';
import ContextMenu from 'components/ContextMenu.vue';
import ContextMenuItem from 'components/ContextMenuItem.vue';
import FlexGridLayoutMaintenanceView from './FlexGridLayoutMaintenanceView.vue';
import { GridController } from 'controller/gridcontroller.js';
import FormListInput from 'components/Form/FormListInput.vue';
import FormDateInput from 'components/Form/FormDateInput.vue';
import ListConfig from 'libs/classes/listconfig.js';
import gridmixin from './mixins/grid.js';
import * as RouterUtils from '@/libs/routerutils';
import RedoButton from '@/components/Buttons/RedoButton.vue';
import PinButton from '@/components/Buttons/PinButton.vue';
import BarcodeInput from './GridBarcodeInput.vue';
import { i18n } from '@/localize';

export default {
  name: 'GridPage',
  mixins: [gridmixin],
  i18n: i18n,
  props: {
    multiSelect: Boolean,
    bottomMargin: {
      type: [String, Number],
      default: 50
    },
    customController: Object,
    singleSelect: Boolean,
    hideFilterButton: {
      type: Boolean,
      default: false
    },
    isHTMLGrid: {
      type: Boolean,
      default: false
    },
    gridBase: {
      default: () => Grid
    },
    gridBaseProps: {
      default: () => ({})
    },
    gridBaseEventListeners: {
      default: () => ({})
    },
    showContainer: {
      type: Boolean,
      default: true
    },
    columnSearch: {
      type: Boolean,
      default: true
    },
  },
  components: {
    'grid': Grid,
    'alerter': Alerter,
    'field-dictionary-search': FieldDictionarySearch,
    'loading-spinner': LoadingSpinner,
    'flex-grid-layout-search': FlexGridLayoutSearch,
    'context-menu': ContextMenu,
    'flex-grid-layout-maintenance-view': FlexGridLayoutMaintenanceView,
    'context-menu-item': ContextMenuItem,
    'form-date-input': FormDateInput,
    'form-list-input': FormListInput,
    'redo-button': RedoButton,
    'pin-button': PinButton,
    'barcode-input': BarcodeInput
  },
  data: function () {
    return {
      urlFilters: [],
      gridSizeComputed: 100,
      showLoadMore: true,
      isLoading: false,
      showPinFilterButton: false
    };
  },
  methods: {
    async refreshDataSetWithPage() {
      let elem = document.getElementById(this.innerGridDivID);
      let scrolltoporg = elem.scrollTop;
      await this.getDataAsync(undefined, false, true);
      this.$nextTick(()=> {
        elem.scrollTop = scrolltoporg;
      });
    },
    async getDataAsync (reloadColumns, search = true, refresh = false) {
      this.allSelected = false; // reset checkboxes
      let self = this;
      self.isLoading = true;

      if (search) {
        // reset page + scroll container to top
        self.selectedPage = 1;
        let scrollcontainer = document.getElementById(this.innerGridDivID);
        if (scrollcontainer !== null)
          scrollcontainer.scrollTop = 0;
      }

      let datafilter = this.getFetchFilter(refresh);
      this.saveState();

      this.$set(this.loader, 'isBusy', true);
      let now = new Date();
      try {
        let res = await this.gridcontroller.GetFlexData(datafilter);
        if (res) {
          self.totalResults = parseInt(res.Meta.Count);
          if (search || refresh) {
            // replace all data
            self.gridData = res.Data;
          } else {
            // loadmore
            self.gridData.push(...res.Data);
          }
          this.$refs.grid.updateRows(self.gridData, (search || refresh));

          self.showLoadMore = datafilter.filter.pageSize === res.Data.length;
          self.gridDataMeta = res.Meta;

          if (reloadColumns) {
            self.gridCols = self.mapLayout(this.getFilteredLayoutColumns(self.gridCols), res.Meta.Columns);
          }

          self.isLoading = false;
        }
      }
      catch(error) {
        self.showAlert(this.$t('errors.error_retrieving'), error);
      }
      finally {
        this.$set(this.loader, 'loadingMessage', this.$t('grid.result_msg', { 0: self.totalResults, 1: (Math.abs(new Date() - now) / 1000) }));
        this.$set(this.loader, 'isBusy', false);
      }
    },
    getData: function (reloadColumns, search = true) {
      // this.allSelected = false; // reset checkboxes
      // this.$emit('unselect-all');
      let self = this;
      self.isLoading = true;

      if (search) {
        // reset page + scroll container to top
        self.selectedPage = 1;
        let scrollcontainer = document.getElementById(this.innerGridDivID);
        if (scrollcontainer !== null)
          scrollcontainer.scrollTop = 0;
      }

      let datafilter = this.getFetchFilter();
      this.saveState();

      this.$set(this.loader, 'isBusy', true);
      let now = new Date();

      this.gridcontroller.GetFlexData(datafilter).then(res => {
        self.totalResults = parseInt(res.Meta.Count);
        if (search) {
          // replace all data
          self.gridData = res.Data;
        } else {
          // loadmore
          self.gridData.push(...res.Data);
        }
        this.$refs.grid.updateRows(self.gridData, (search));

        self.showLoadMore = datafilter.filter.pageSize === res.Data.length;
        self.gridDataMeta = res.Meta;

        if (reloadColumns) {
          self.gridCols = self.mapLayout(this.getFilteredLayoutColumns(self.gridCols), res.Meta.Columns);
        }

        self.isLoading = false;
      }).catch(error => self.showAlert(this.$t('errors.error_retrieving'), error)).finally(() => {
        this.$set(this.loader, 'loadingMessage', this.$t('grid.result_msg', { 0: self.totalResults, 1: (Math.abs(new Date() - now) / 1000) }));
        this.$set(this.loader, 'isBusy', false);
      });
    },
    showAlert: function (msg, error) {
      console.error(error, this.$refs.alertbox);
      this.$refs.alertbox.showError(msg);
    },
    getURLParameters: function () {
      let keyPairs = [];
      let params = {};
      
      // verschillende router implementaties
      if (this.$router && this.$router.mode === 'hash') {
        params = this.$route.query;
      } else if (this.$router && this.$router.mode === 'abstract') {
        let uri = RouterUtils.parsePath(window.location.href);
        params = RouterUtils.resolveQuery(uri.query);
      }

      for (let prop in params) {
        if (prop.startsWith('$')) continue;
        keyPairs.push([prop, params[prop]]);
      }
      
      for (let index of keyPairs) {
        if (index[0] !== '' && index[1] != null) {
          this.setExternalFilterValue(index);
        }
      }

      if (params.$dataset) {
        this.selectedDataSource = params.$dataset;
      }

      return (keyPairs.length > 0 || (params.$dataset !== null || params.$dataset !== undefined)) || false;

    },
    hasURLParameters: function () {
      let keyPairs = [];
      let params = {};
      
      // verschillende router implementaties
      if (this.$router && this.$router.mode === 'hash') {
        params = this.$route.query;
      } else if (this.$router && this.$router.mode === 'abstract') {
        let uri = RouterUtils.parsePath(window.location.href);
        params = RouterUtils.resolveQuery(uri.query);
      }

      for (let prop in params) {
        if (prop.startsWith('$')) continue;
        keyPairs.push([prop, params[prop]]);
      }
      return (keyPairs.length > 0 || (params.$dataset !== null && params.$dataset !== undefined)) || false;
    },
    // Search for external filter and change value, or set a new column filter based on the
    setExternalFilterValue: function (pair) {
      let key = pair[0];
      let value = pair[1];
      
      let filter = null;
      for (let f of this.filters) {
        if (f.selector.toLowerCase() === key.toLowerCase()) {
          filter = f;
        }
      }

      try {
        if (filter == null) {
          const newUrlFilter = {
            selector: key,
            selectedKey: value
          };
          this.urlFilters.push(newUrlFilter);
        } else {
          this.$set(filter, 'selectedKey', parseInt(value));
        }
      } catch (err) {
        console.error('filter not found', err);
      }
    },
    isElementInViewport: function (el) {
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)/* or $(window).width() */
      );
    },
    updateHeight: function () {
      let self = this;
      let innergrid = document.getElementById(this.innerGridDivID);
      if (innergrid) {
        if (this.wrapperDivId !== null && this.wrapperDivId.length > 0) {
          let wrapperdiv = document.getElementById(this.wrapperDivId);
          if (wrapperdiv) {
            let inner = wrapperdiv.getBoundingClientRect();
            self.gridSizeComputed = inner.height - this.bottomMargin;
          }
        } else {
          // use window
          let rect = innergrid.getBoundingClientRect();
          self.gridSizeComputed = (window.innerHeight - rect.top - this.bottomMargin);
        }
      }
    },
    throttledUpdateHeight: lodashDebounce(function () {
      this.updateHeight();
    }, 200),
    toPixels: function (str) {
      return str + 'px';
    },
    getListConfig(singleMethod, listMethod, controller = null) {
      return new ListConfig(listMethod, singleMethod, null, controller);
    },
    refreshButtonClicked(){
      if(this.isLoading === false){
        this.getData(false);
      }
    },
    pinButtonClicked() {
      this.setPinnedFilter(!this.pinnedFilter);
    }
  },
  computed: {
    gridID () {
      return this._uid + 'grid';
    },
    innerGridDivID () {
      return 'inner-grid-div' + this.gridID;
    },
    hasFilters() {
      return ((this.filters && this.filters.length > 0) || (this.dateFilters && this.dateFilters.length > 0));
    }
  },
  created () {
    this.pageSize = this.forcedPageSize;
  },
  mounted: function () {
    let maxHeight = this.maxHeight;
    if (maxHeight) {
      this.$el.style.maxHeight = maxHeight + 'px';
    }

    if (this.customController) {
      this.$log('custom controller', this.customController);
      this.gridcontroller = this.customController;
    } else {
      this.gridcontroller = new GridController(this.config.webController);
    }

    let self = this;
    this.updateHeight();

    $(window).on('resize', lodashDebounce(function () {
      self.updateHeight();
    }, 200));

    let divid = '#' + this.$refs.grid.loadMoreDivID;
    let innergrid = '#' + this.innerGridDivID;
    $(innergrid).on('scroll', lodashDebounce(function () {
      let loadelem = document.querySelector(divid);
      if (loadelem && self.isElementInViewport(loadelem)) {
        self.loadMore();
      }
    }, 200));

    if (!this.autoLoad) {
      return;
    }

    // restore state
    var perfData = window.performance;
    const restoreLocalState = (perfData.navigation.type === PerformanceNavigation.TYPE_BACK_FORWARD);
    const hasURLParameters = this.hasURLParameters();
    if (!hasURLParameters) {
      // indien er url parameters zijn meegegeven wordt de pin functionaliteit uitgeschakeld en de pin verborgen
      this.showPinFilterButton = true;
    }
    if (restoreLocalState && this.restoreState()) {
      this.getData(true);
    } else if (!hasURLParameters && this.pinnedFilter && this.restoreState(true)) {
      this.getData(true);
    } else {
      this.getURLParameters();
      this.getFlexLayout(this.getData);
    }

    if (window.ResizeObserver) {
      new ResizeObserver(() => {
        this.updateHeight();
      }).observe(document.getElementById(this.gridID));
      
      if (this.wrapperDivId !== null && this.wrapperDivId.length > 0) {
        let wrapperdiv = document.getElementById(this.wrapperDivId);
        if (wrapperdiv) {
          new ResizeObserver(() => {
            this.throttledUpdateHeight();
          }).observe(wrapperdiv);
        }
      }
    }
  }
};
</script>

<style lang="scss">
.centix-grid-page {
  background: #f2f4f6;
  .filter-container {
    .container {
      padding-top: 0;
    }
  }
  .filter-button {
    width: 100%;
    text-decoration: none;
  }
  .filter-dropdown {
    min-width: 360px;
  }
  .grid-container-row {
    height: 80vh;
    overflow: auto; //(GOED CONTROLEREN)
    // iOS fluid scrolling
    -webkit-overflow-scrolling: touch;
  }
}
.footerContainer {
  display: none !important;
}
.contentContainer {
  padding-bottom: 0 !important;
}
.refresh_holder {
  display: inline-block;
  height: calc(2.25rem + 2px);
}
</style>